import Vue from 'vue'
import Vuex from 'vuex'
import { set } from './util'
import example from './sample.json'
import _ from 'lodash'
import axios from 'axios'
import createPersistedState from 'vuex-persistedstate'
Vue.use(Vuex)
//1953부터 1968까지
//1969부터 65세
const pensionYear = {
  1953: 60,
  1954: 61,
  1955: 61,
  1956: 61,
  1957: 62,
  1958: 62,
  1959: 62,
  1960: 62,
  1961: 63,
  1962: 63,
  1963: 63,
  1964: 63,
  1965: 64,
  1966: 64,
  1967: 64,
  1968: 64,
}

export default new Vuex.Store({
  plugins: [createPersistedState()],
  state: {
    hasCompareAggregation: false,
    compareAggregation: {},
    isSentEmail: false,
    uploadedFileId: '',
    comment: '',
    classId: 'nil',
    className: '',
    currentYear: 2023,
    userEmail: '',
    userNick: '',
    id: '',
    master: {},
    finance: {},
    life: {},
    career: {},
    action: {},
    housePension: {},
    me: {
      birthAt: undefined,
      retire: undefined,
      pension: undefined,
    },
    wife: {
      birthAt: undefined,
      retire: undefined,
      pension: undefined,
    },
    children: [
      // {
      //   seq: 0,
      //   birthAt: 1990,
      //   admissionAt: 2010,
      //   jobAt: 2020,
      //   marry: 31,
      // },
      // {
      //   seq: 1,
      //   birthAt: 1995,
      //   admissionAt: 2015,
      //   jobAt: 2023,
      //   marry: 31,
      // },
    ],
    parents: [
      // { seq: 0, title: '부모님1', birthAt: 1930, care: 75 },
      // { seq: 1, title: '부모님2', birthAt: 1932, care: 75 },
    ],
    exit: [
      { name: '퇴직', issue: '' },
      { name: '막내결혼', issue: '' },
      { name: '국민연금수령', issue: '' },
      { name: '상배', issue: '' },
    ],
    isCompleted: false,
  },
  getters: {
    isLoggedIn(state) {
      return state.userEmail !== '' && state.id !== '' && state.userNick !== ''
    },
    getCellLength(state) {
      const nintyAt = state.me.birthAt + 91
      // console.log(nintyAt, state.currentYear)
      return nintyAt - state.currentYear
      // return 40
    },
    exit(state, getters) {
      // this.setExample()
      // console.log(state.me)
      const exit = getters.getExit
      //exit 이벤트 (은퇴, 연금 등 )
      //은퇴 => 퇴직으로
      const t = [...new Array(getters.getCellLength)]
      //예상월생활비
      const l = [...new Array(getters.getCellLength)]
      //나이
      const m = [...new Array(getters.getCellLength)].map((o, i) => state.currentYear - state.me.birthAt + i)

      //나
      const pmv1 = state.finance['재무-연금준비상황1'].value[0].value * 35 // 100000000 //퇴직연금
      const pmv2 = state.finance['재무-연금준비상황1'].value[1].value * 35 // 100000000 //개인연금
      const pmv3 = Number(state.finance['재무-연금준비상황1'].value[2].value) // 10000 //국민연금
      //배우자
      const pwv1 = state.finance['재무-연금준비상황2'].value[0].value * 35 // 100000000 //퇴직연금
      const pwv2 = state.finance['재무-연금준비상황2'].value[1].value * 35 // 100000000 //개인연금
      const pwv3 = Number(state.finance['재무-연금준비상황2'].value[2].value) // 10000 //국민연금

      const pm1 = m.slice(0).map((o) => {
        if (o > state.me.retire) return pmv1
        else return null
      })
      const pm2 = m.slice(0).map((o) => {
        if (o > 54) return pmv2
        else return null
      })
      const pm3 = m.slice(0).map((o) => {
        if (o > state.me.pension - 1) return pmv3
        else return null
      })

      const w = [...new Array(getters.getCellLength)].map((o, i) => state.currentYear - state.wife.birthAt + i)
      const w1 = w.map((o) => {
        // if (state.wife.retire && o === 55) return '임피' //임피안뜨게
        if (state.wife.retire && o === 60) return '정년'
        else if (state.wife.retire && o === 64) return '연금'
        else return ''
      })

      const pw1 = w.slice(0).map((o) => {
        if (state.wife.retire === undefined) return null
        if (o > state.wife.retire) return pwv1
        else return null
      })
      const pw2 = w.slice(0).map((o) => {
        if (o > 54) return pwv2
        else return null
      })
      const pw3 = w.slice(0).map((o) => {
        if (o > state.wife.pension - 1) return pwv3
        else return null
      })

      const k = exit.map((o) => {
        return { ...o, index: o.year - state.currentYear }
      })

      const kk = _.orderBy(k, ['index'])
      k.forEach((e) => {
        t[e.index] = e.name
      })
      console.log('==>', t)
      const pensionIdx = t.indexOf('연금')
      //event
      const m1 = m.map((o, k) => {
        if (o === 56) return '임피'
        else if (o === 60) return '정년'
        else if (k === pensionIdx) return '연금'
        else return ''
      })
      // console.log(kk)

      // console.log(this.finance['재무-근로소득'])
      const salary = state.finance['재무-근로소득'].value[0].value /// 10000

      //예상월생활비
      const expectedLivingCost = state.finance['재무-생활비'].value[0].value

      // console.log(k, kk)
      const ll = l.map((o, i) => {
        // if(m[i]-55 > 0) return o * Math.pow(0.1, m[i]-55 )
        // else return o
        if (i < kk[0].index) return Number(expectedLivingCost)
        else if (i < kk[1].index) return expectedLivingCost - 50
        else return expectedLivingCost - 100
      })
      //주택연금
      const hpv = state.finance['재무-주택연금'].value
      let hp = []
      console.log('hpv =>', hpv)

      if (!hpv[0].isSkipped && hpv[1].value < 10) {
        const hpv0 = hpv[0].value
        const hpv1 = Math.round(hpv[1].value)

        console.log(state.housePension)
        console.log(state.housePension[hpv[0].value])
        const pension = state.housePension[hpv0][hpv1 - 1]
        // console.log(hpv[1] / 100000000 - 1)
        // console.log(pension)
        hp = m.map((o) => {
          if (o > hpv[0].value - 1) return pension
          else null
        })
      }

      const meAge = state.currentYear - state.me.birthAt

      const salaryPeakAge = meAge > 55 ? meAge : 55
      console.log('==> sp', salaryPeakAge)

      //근로소득
      const sv = m.map((o, i) => {
        const e = m[i] < salaryPeakAge ? 1 : Math.pow(0.9, m[i] - salaryPeakAge)
        if (o > state.me.retire) return null
        else return Math.floor(salary * e)
      })
      // console.log(salary, state.me.retire, m)

      //기타
      const ev = m.map((o) => {
        if (o > state.me.retire)
          return state.finance['재무-연금화자산'].value.reduce((a, c) => {
            a += Number(c.value)
            return a
          }, 0)
        /// 10000
        else return null
      })
      const sum = m.map((o, i) => {
        return (pm3[i] || 0) + (pm2[i] || 0) + (pm1[i] || 0) + (pw3[i] || 0) + (pw2[i] || 0) + (pw1[i] || 0) + (hp[i] || 0) + (sv[i] || 0) + (ev[i] || 0)
      })

      const cashFlow = sum.map((o, i) => {
        return o - ll[i]
      })
      const crevasse = cashFlow
        .map((c, i) => {
          if (c < 0) return m[i]
          else return 0
        })
        .filter((c) => c > 0)
      // console.log(crevasse)
      // console.log(cashFlow)
      // console.log(m)

      return [t, ll, m, m1, pm3, pm1, pm2, w, w1, pw3, pw1, pw2, hp, sv, ev, sum, cashFlow, crevasse].map((k, i) => {
        if (i === 0) return k
        else return k.map((o) => (o ? Number(o).toFixed(1).replace(/\.0/, '') : null))
      })
    },
    exportData(state) {
      return state
    },
    hasWife(state) {
      console.log(state.wife.birthAt)
      return (state.wife.birthAt || 1900) > 1950 ? true : false
    },
    getChildrenCount(state) {
      return state.children.length
    },
    getParentsCount(state) {
      return state.parents.length
    },
    getWifeExit(state) {
      const wifeRetire = { name: '퇴직', year: state.wife.birthAt + state.wife.retire + 1, age: state.wife.retire + 1 }
      console.log(wifeRetire, state.wife.birthAt, state.wife.retire)
      const wifePension = { name: '연금', year: (pensionYear[state.wife.birthAt] || 65) + state.wife.birthAt, age: pensionYear[state.wife.birthAt] || 65 }
      console.log(wifePension)

      return {
        pension: wifePension,
        retire: wifeRetire,
      }
    },
    getExit(state) {
      if (!state.isCompleted)
        return [
          { name: '연금', year: 2025, age: 63 },
          { name: '상배', year: 2049, age: 87 },
          { name: '결혼', year: 2021, age: 31 },
          { name: '퇴직', year: 2020, age: 65 },
        ]
      const exitRetire = { name: '퇴직', year: state.me.birthAt + state.me.retire, age: state.me.retire }

      console.log(exitRetire, state.me.birthAt, state.me.retire)
      let exitChildMarryRetire = { name: '결혼', year: 0, age: 0 }
      const lastChild = state.children.slice(0).reverse().shift()

      if (state.children.length === 0) exitChildMarryRetire = {}
      else exitChildMarryRetire = { name: '결혼', year: lastChild.marriedAt, age: lastChild.marriedAt - state.me.birthAt }
      console.log(exitChildMarryRetire)

      const exitPension = { name: '연금', year: (pensionYear[state.me.birthAt] || 65) + state.me.birthAt, age: pensionYear[state.me.birthAt] || 65 }
      console.log(exitPension)
      const exitPassaway = { name: '상배', year: state.me.birthAt + 87, age: 87 }
      console.log(exitPassaway)

      const exit = [exitRetire, exitPension, exitPassaway]

      if (state.children.length > 0) exit.push(exitChildMarryRetire)
      console.log(exit)

      return _.orderBy(exit, ['age'], ['asc'])
    },
    getFinanceGoalMoney(state) {
      const v = state.finance['재무-목적자금-우선순위'].list
      const kk = _.keyBy(state.finance['재무-목적자금-계획'].value, 'title')

      const t = v.map((o) => ({
        ...o,
        money: kk[o.title].value[0], // 1000000,
        age: kk[o.title].value[1],
      }))

      return _.orderBy(t, ['order'], ['asc'])
    },
  },
  mutations: {
    setCompareAggregation(state, payload) {
      if (payload?.id) {
        state.compareAggregation = payload
        state.hasCompareAggregation = true
      } else {
        state.compareAggregation = {}
        state.hasCompareAggregation = false
      }
    },
    setUploadFileId(state, id) {
      state.uploadedFileId = id
    },
    setSentEmail(state) {
      state.isSentEmail = true
    },
    initialize(state) {
      const init = {
        hasCompareAggregation: false,
        compareAggregation: {},
        isSentEmail: false,
        uploadedFileId: '',
        classId: 'nil',
        className: '',
        currentYear: new Date().getFullYear(),
        userEmail: '',
        userNick: '',
        id: '',
        master: {},
        finance: {},
        life: {},
        career: {},
        action: {},
        housePension: {},
        me: {
          birthAt: undefined,
          retire: undefined,
          pension: undefined,
        },
        wife: {
          birthAt: undefined,
          retire: undefined,
          pension: undefined,
        },
        children: [],
        parents: [],
        exit: [
          { name: '퇴직', issue: '' },
          { name: '막내결혼', issue: '' },
          { name: '국민연금수령', issue: '' },
          { name: '상배', issue: '' },
        ],
        isCompleted: false,
      }
      Object.keys(init).forEach((key) => {
        state[key] = init[key]
      })
    },
    setComment(state, payload) {
      state.comment = payload
    },
    setClass(state, payload) {
      state.classId = payload.id
      state.className = payload.title
    },
    setClassId: set('classId'),
    setHousePension(state, payload) {
      state.housePension = payload
    },
    loadFile: (state, payload) => {
      //   state = {}
      //   console.log(payload)
      state.userEmail = payload.userEmail

      Object.keys(payload).forEach((key) => {
        if (key !== 'housePension') state[key] = payload[key]
        // console.log(state[key])
      })
      // state.openFile = true
      console.log('file loaded!!', state.userEmail)
    },
    setExample: (state, paylod) => {
      Object.keys(example).forEach((key) => {
        state[key] = example[key]
        // console.log(state[key])
      })

      // state.master = masterExample
      // state.finance = financeExample
    },
    setUp: (state, payload) => {
      state.isSentEmail = false
      state.uploadedFileId = ''
      Object.keys(payload).forEach((key) => {
        state[key] = payload[key]
      })
    },
    setUserEmail: set('userEmail'),
    setUserNick: set('userNick'),
    setId: set('id'),
    setMaster: (state, payload) => {
      console.log(payload)
      const { id, ...rest } = payload
      state.master[payload.id] = rest
    },
    setFinance: (state, payload) => {
      console.log(payload)
      const { id, ...rest } = payload
      state.finance[payload.id] = rest
    },
    setCareer: (state, payload) => {
      console.log(payload)
      const { id, ...rest } = payload
      state.career[payload.id] = rest
    },
    setAction: (state, payload) => {
      console.log(payload)
      const { id, ...rest } = payload
      state.action[payload.id] = rest
    },
    setLife: (state, payload) => {
      console.log(payload)
      const { id, ...rest } = payload
      state.life[payload.id] = rest

      if (id === '라이프-가족-부부') {
        state.me.birthAt = Number(rest.value[0].value)
        state.me.pension = pensionYear[state.me.birthAt] || 65

        if (!rest.value[1].isSkipped) {
          state.wife.birthAt = Number(rest.value[1].value)
          state.wife.pension = pensionYear[state.wife.birthAt] || 65
        } else state.wife = {}
      } else if (id === '라이프-가족-자녀') {
        state.children = rest.value.slice(0, rest.option.count).map((v, i) => {
          return {
            seq: i,
            title: v.text,
            birthAt: Number(v.value),
          }
        })
      } else if (id === '라이프-가족-부양부모') {
        state.parents = rest.value.slice(0, rest.option.count).map((v, i) => {
          return {
            seq: i,
            title: v.text,
            birthAt: Number(v.value),
          }
        })
      } else if (id === '라이프-퇴직') {
        state.me.retire = Number(rest.value[0].value)
        if (rest.value.length > 1 && !rest.value[1].isSkipped) state.wife.retire = Number(rest.value[1].value)
        else state.wife.retire = undefined
      } else if (id === '라이프-자녀이벤트') {
        const childrenCount = state.children.length
        rest.value.slice(0, childrenCount).map((v, i) => {
          state.children[i].admissionAt = state.children[i].birthAt + Number(v.value[0])
          state.children[i].jobAt = state.children[i].birthAt + Number(v.value[1])
          state.children[i].marriedAt = state.children[i].birthAt + Number(v.value[2])
          state.children[i].marry = Number(v.value[2])
        })
      } else if (id === '라이프-부모가료') {
        const pc = state.parents.length
        rest.value.slice(0, pc).map((v, i) => {
          state.parents[i].care = Number(v.value)
        })
        state.isCompleted = true
      }
    },
  },
  actions: {
    submit({ state, commit }) {
      const val = _.cloneDeep(state)
      delete val.housePension
      const data = {
        state: val,
      }
      return axios.patch('api/workbook/' + state.id, data).then((res) => {
        console.log(res.data)
      })
    },
    getClassHash({ state, commit }, { classId }) {
      return axios.get('api/dClass/' + classId).then(({ data }) => {
        return data?.hash
      })
    },
    fetchHousePension({ state, commit }) {
      return axios.get('/api/housePension').then((res) => {
        commit('setHousePension', res.data[0])
        return state.housePension
      })
    },
    signUp({ state, commit }, { classId, username, email }) {
      return axios
        .post('/api/signup', { classId, username, email })
        .then((res) => {
          if (res.status === 201) {
            commit('setUserEmail', email)
            commit('setUserNick', username)
            commit('setId', res.data.userId)
            return [null, true]
          }
        })
        .catch((err) => [true, err])
    },
    login({ state, commit }, { classId, username, email }) {
      return axios
        .post('/api/login', { classId, username, email })
        .then((res) => {
          if (res.status === 200) {
            commit('setUserEmail', res.data.userEmail)
            commit('setUserNick', res.data.userNick)
            commit('setId', res.data.id)

            return axios.get('/api/workbook/' + state.id).then(({ data }) => {
              const st = data.state
              const comment = data.comment || ''

              commit('setComment', comment)

              commit('setUp', data.state)

              return [null, true]
            })
          }
        })
        .catch((err) => [true, err])
    },
  },
  modules: {},
})
